var map = {
	"./BAT-USDC.png": "3b8c",
	"./BTC-USD.png": "37d5",
	"./COMP-USD.png": "4f1f",
	"./DAI-USDC.png": "fbc4",
	"./ETH-USD.png": "eac9",
	"./KNC-USD.png": "50b6",
	"./LINK-USD.png": "6b0b",
	"./REP-USD.png": "7d6d",
	"./USDC.png": "708b",
	"./XTZ-USD.png": "1562",
	"./ZRX-USD.png": "0d59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";